import { Tooltip } from "@mui/material";
import { FormikSelectField } from "src/components/FormikComponents/FormikWrappers";
import { SelectField } from "src/components/FormikComponents/SelectField";
import { Grid } from "@mui/material";
import { useEffect } from "react";

interface IDefinitionEndProps {
  initialValue: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

interface IDaysOfMonthOption {
  label: string;
  value: number;
}

const daysOfMonthOptions = (): IDaysOfMonthOption[] => {
  const daysOfMonth: IDaysOfMonthOption[] = [];
  for (let i = 1; i < 32; i++) {
    daysOfMonth.push({ label: `${i}`, value: i });
  }
  return daysOfMonth;
};

export const DefinitionEnd = (props: IDefinitionEndProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <Tooltip title="Match results only include pairings starting before calendar date" placement="top">
      <div>
        <SelectField
          name="definition_endday"
          className={`end_control ${isDirty ? "dirty" : ""}`}
          label="End"
          onChange={(dom: IDaysOfMonthOption) => {
            onChange(dom?.value ?? null);
          }}
          value={daysOfMonthOptions().find((o) => o.value === value)}
          options={daysOfMonthOptions()}
          meta={{
            initialValue: initialValue,
            touched: isDirty,
          }}
          placeholder=""
          isClearable={true}
          isSearchable={true}
          maxMenuHeight={200}
          disabled={disabled}
        />
      </div>
    </Tooltip>
  );
};
